import { Stack, Text } from '@trmediaab/zebra';

const BoxedContent = ({ title, children, ...props }) => (
  <Stack
    between="2,5"
    pt="3,5"
    pb="26px"
    px="3"
    backgroundColor="white"
    {...props}
  >
    <Text fontWeight="extraBold" fontSize="0" color="brands.travrondenSpel">
      {title}
    </Text>
    {children}
  </Stack>
);

export default BoxedContent;
